import React from "react";
import { Card, CardContent } from "@tonic/shared/components/ui";
import { Badge } from "@tonic/shared/components/ui";
import { LineChart, BarChart } from "@/components/ui/charts";
import { useInboundMetrics } from "../hooks/useInbound";

export function InboundOverviewPage() {
  const { data: metrics, isLoading } = useInboundMetrics();

  const monthlyData = [
    { timestamp: "2024-01-01", value: 45 },
    { timestamp: "2024-02-01", value: 52 },
    { timestamp: "2024-03-01", value: 48 },
    { timestamp: "2024-04-01", value: 55 },
    { timestamp: "2024-05-01", value: 59 },
    { timestamp: "2024-06-01", value: 65 },
  ];

  const locationData = [
    { name: "New York", value: 35 },
    { name: "Los Angeles", value: 28 },
    { name: "Chicago", value: 22 },
    { name: "Houston", value: 18 },
    { name: "Phoenix", value: 15 },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Inbound Overview</h1>
          <p className="text-muted-foreground">
            Monitor and manage all incoming items across locations
          </p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-muted-foreground">
                Total Shipments
              </span>
              <div className="flex items-baseline gap-2">
                <span className="text-2xl font-bold">156</span>
                <Badge className="bg-green-500">+8%</Badge>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-muted-foreground">
                Pending Items
              </span>
              <div className="flex items-baseline gap-2">
                <span className="text-2xl font-bold">45</span>
                <Badge className="bg-yellow-500">+12%</Badge>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-muted-foreground">
                Processing
              </span>
              <div className="flex items-baseline gap-2">
                <span className="text-2xl font-bold">32</span>
                <Badge className="bg-red-500">-5%</Badge>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-muted-foreground">
                Completed
              </span>
              <div className="flex items-baseline gap-2">
                <span className="text-2xl font-bold">79</span>
                <Badge className="bg-green-500">+15%</Badge>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardContent className="p-6">
            <h2 className="text-lg font-semibold mb-4">Monthly Performance</h2>
            <LineChart
              data={monthlyData}
              height={320}
              yLabel="Shipments"
            />
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <h2 className="text-lg font-semibold mb-4">Location Distribution</h2>
            <BarChart
              data={locationData}
              height={320}
              dataKeys={["value"]}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default InboundOverviewPage;
